import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../context/authContext";
import { useMaincategory, useMain, useMainAllcategory } from "../../actions/homeActions";
export default () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const userData = useSelector((state) => state.app.userData.userData);
  const [categoriesTtypesMainId, setCategoriesTtypesNewsId] = useState(2);
  const {
    data: CategoriesTypesMain,
    isLoading,
    isError,
    error,
  } = useMainAllcategory("main"); // useMaincategory("main");
  const {
    data: Main,
    isLoading: MainisLoading,
    isError: MainisError,
    error: MainError,
  } = useMain(categoriesTtypesMainId);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Categories Types Main: {error.message}
        </p>
      </div>
    );
  }

  if (MainisError) {
    return (
      <div className="flex items-center justify-center w-full ">
        <p className="text-secondary">
          Error loading Main: {MainError.message}
        </p>
      </div>
    );
  }
  
  const handleButtonClick = (id) => {
    setCategoriesTtypesNewsId(id);
  };

  const handleTalent = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (userData?.role === "fan") {
      navigate("/upgrade");
    } else {
      navigate(`/talent/${id}`);
    }
  };
  return {
    CategoriesTypesMain,
    isLoading,
    Main,
    MainisLoading,
    handleButtonClick,
    categoriesTtypesMainId,
    handleTalent,
  };
};
